import { Metamodel } from '../base/model';
import { IAttribute, IModel, IViolation, ModelConstants } from 'shell-models-lib';
import { Activity } from './activity';

import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.failActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.FailActivityLabel),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.FailActivityLabel)
    ],
    referable: true
})
export class FailActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly MESSAGE: IAttribute;
    public static readonly ERROR_CODE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.FailActivity_FailMessage,
        association: 'MESSAGE',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: FailActivity._failMessageValidator
        }
    })
    public failMessage: string;

    @Metamodel.attribute({
        display: stringResources.ErrorCode,
        association: 'ERROR_CODE',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: FailActivity._errorCodeValidator
        }
    })
    public errorCode: string;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ControlActivity';
    }

    private static _failMessageValidator(failActivity?: FailActivity, failMessage?: string): IViolation[] | undefined {
        if (failActivity) {
            if (!failMessage) {
                return [
                    {
                        message: () => stringResources.FailActivity_FailMessageRequired
                    }
                ];
            } else if (typeof failMessage !== 'string') {
                return [
                    {
                        message: () => stringResources.FailActivity_FailMessageNotString
                    }
                ];
            } else if (failMessage.split(' ').length - 1 === failMessage.length) {
                return [
                    {
                        message: () => stringResources.FailActivity_FailMessageWhitespacesError
                    }
                ];
            }
        }
        return undefined;
    }

    private static _errorCodeValidator(failActivity?: FailActivity, errorCode?: string): IViolation[] | undefined {
        if (failActivity) {
            if (!errorCode) {
                return [
                    {
                        message: () => stringResources.FailActivity_ErrorCodeRequired
                    }
                ];
            } else if (typeof errorCode !== 'string') {
                return [
                    {
                        message: () => stringResources.FailActivity_ErrorCodeNotString
                    }
                ];
            } else if (errorCode.split(' ').length - 1 === errorCode.length) {
                return [
                    {
                        message: () => stringResources.FailActivity_ErrorCodeWhitespacesError
                    }
                ];
            }
        }
        return undefined;
    }
}
